import React from 'react';
import { useSearchParams } from 'react-router-dom';

import { useGetRouteParams } from '../../hooks/tanstack/useUtilsHook';
import useExpenseStore from '../../hooks/zustand/useExpenseStore';

import CheckboxesCollapse from './CheckboxesCollapse';

export type SimpleExpenseSet = {
  id: number;
  name: string;
  description: string;
  formula: string;
  type: 'default' | 'user';
  is_locked: boolean;
  group: {
    id: number;
    name: string;
    ifs_order: number;
  };
};

const CreateExpenseForm = ({
  data,
  disabled,
  isSubmitting,
}: {
  disabled?: boolean;
  data: SimpleExpenseSet[][];
  isSubmitting?: boolean;
}) => {
  const { orgId, projectId } = useGetRouteParams();

  const [searchParams] = useSearchParams();

  const modelType = searchParams.get('type');

  const setIsOpenAddingExpense = useExpenseStore(
    (state) => state.setIsOpenAddingExpense
  );

  const setDefaultExpenseCategory = useExpenseStore(
    (state) => state.setDefaultExpenseCategory
  );

  const handleRedirectAddNewExpense = ({ category }: { category: string }) => {
    if (window) {
      setDefaultExpenseCategory(category);
      setIsOpenAddingExpense(true);

      window
        .open(`/${orgId}/projects/${projectId}/expenses`, '_blank')
        ?.focus();
    }
  };

  return (
    <div className="rounded-[4px] border border-[#E4E7EC] bg-[#FFF] p-2">
      <div>
        {data &&
          data?.length > 0 &&
          Array.from(Array(data.length - 1).keys()).map((_, index) => {
            const items = data[index + 1];

            if (!items) {
              return null;
            }

            const groupName = items[0].group.name;

            return (
              <CheckboxesCollapse
                name={groupName}
                title={groupName}
                key={groupName}
                category={groupName}
                handleAddExpense={handleRedirectAddNewExpense}
                disabled={isSubmitting || disabled}
                items={items
                  .filter((i) =>
                    modelType !== 'received' && modelType !== 'shared'
                      ? i.is_locked === false
                      : true
                  )
                  .map((e) => ({
                    label: e.name,
                    value: e.id,
                    type: e.type,
                  }))}
              />
            );
          })}
      </div>
    </div>
  );
};

export default CreateExpenseForm;
